import { z } from 'zod';

export enum ReportTab {
    Reservations = 'Reservations',
    SpaceBlocks = 'SpaceBlocks',
}

export const activeTabUrlSchema = z
    .object({
        activeTabId: z.nativeEnum(ReportTab),
    })
    .partial();
